'use strict';

const IABActions = require('../../components/ItemActionButtons/actions/IABActions.es');
const PurchaseTracking = require('../../global/mixins/purchaseTracking.es');

module.exports = {
    makeOffer(actionContext, payload) {
        const { item,
                pageData,
                referredFromAmp,
                queryEmailTemplate } = payload;
        const props = {
            item,
            referredFromAmp,
            tracking: {
                emailTmplName: queryEmailTemplate || '',
                pageContext: 'pdp'
            }
        };

        const purchaseTracking = new PurchaseTracking({
            item,
            pageContext: props.tracking.pageContext
        });

        purchaseTracking.url = pageData && pageData.canonicalUrl || document.URL;

        actionContext.executeAction(IABActions.MakeOfferActions.renderModal, {
            props,
            modalId: props.item.id + '-offer',
            linkLocation: props.tracking.emailTmplName,
            purchaseTracking
        });

        if (props.tracking.emailTmplName) {
            actionContext.executeAction(IABActions.MakeOfferActions.trackPageLoadModal, {
                props,
                purchaseTracking
            });
        } else if (props.referredFromAmp) {
            actionContext.executeAction(IABActions.MakeOfferActions.trackPageLoadModal, {
                props,
                purchaseTracking
            });
            purchaseTracking.ecommerceAddToCartTracking({ url: purchaseTracking.url });
        }
    }
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/actions/makeOfferActions.es.js